










































import { Component, Vue, Watch } from 'vue-property-decorator'
import HeadLable from '@/components/HeadLable/index.vue'
import ImageUpload from '@/components/ImgUpload/index.vue'
import { addOpen, querySmallProgramById, updateSmallProgram } from '@/api/competition.ts';
import { baseUrl } from '@/config.json'
import { getToken } from '@/utils/cookies'
@Component({
  name: 'addPromotionalImage',
  components: {
    HeadLable,
    ImageUpload
  }
})
export default class extends Vue {
  private restKey: number = 0
  private title = '新建小程序';
  private textarea: string = ''
  private value: string = ''
  private imageUrl: string = ''
  private actionType: string = 'add'
  private dishList: string[] = []
  private vueRest = '1'
  private index = 0
  private inputStyle = { flex: 1 }
  private titleId = ''
  private headers = {
    token: getToken()
  }
  private ruleForm = {
    id: '',
    content: '',
  }

  get rules() {
    return {
      content: {
        required: true,
        message: '赛事Id不能为空'
      }
    }
  }

  created() {
    this.titleId = this.$route.query.titleId;
    this.actionType = this.$route.query.id ? 'edit' : 'add';
    if (this.$route.query.id) {
      this.title = '修改小程序信息';
      this.init();
    }
  }

  private async init() {
    const params = {
      id: this.$route.query.id,
      type: 2
    };
    querySmallProgramById(params).then(res => {
      if (res && res.data && res.data.code === 1) {
        this.imageUrl = res.data.data.image
        this.ruleForm.content = res.data.data.titleId
        this.ruleForm.id = res.data.data.id
      } else {
        this.$message.error(res.data.msg)
      }
    })
  }

  cancel() {
    this.$router.push({ path: '/competition/smallProgramManage', query: { titleId: this.titleId } })
  }

  private submitForm(formName: any, st: any) {
    ;(this.$refs[formName] as any).validate((valid: any) => {
      console.log(valid, 'valid')
      if (valid) {
        if (!this.ruleForm.content) return this.$message.error('小程序不能为空')
        // let params: any = { ...this.ruleForm }
        let params: any = {}
        // params.flavors = this.dishFlavors
        params.titleId = this.ruleForm.content
        params.type = 2
        // params.price *= 100
        if (this.actionType == 'add') {
          params.titleId = this.titleId
          delete params.id
          addOpen(params)
            .then(res => {
              if (res.data.code === 1) {
                this.$message.success('小程序添加成功！')
                  this.$router.push({ path: '/competition/smallProgramManage', query: { titleId: this.titleId } })
              } else {
                this.$message.error(res.data.desc || res.data.msg)
              }
            })
            .catch(err => {
              this.$message.error('请求出错了：' + err.message)
            })
        } else {
          delete params.createTime
          delete params.updateTime
          params.id = this.ruleForm.id
          updateSmallProgram(params)
            .then(res => {
              if (res && res.data && res.data.code === 1) {
                this.$router.push({ path: '/competition/smallProgramManage', query: { titleId: this.titleId } })
                this.$message.success('小程序修改成功！')
              } else {
                this.$message.error(res.data.desc || res.data.msg)
              }
              // if (res.data.code == 200) {
              //   this.$router.push({'path': '/dish'})
              //   this.$message.success('菜品修改成功！')
              // } else {
              //   this.$message.error(res.data.desc || res.data.message)
              // }
            })
            .catch(err => {
              this.$message.error('请求出错了：' + err.message)
            })
        }
      } else {
        return false
      }
    })
  }

  imageChange(value: any) {
    this.ruleForm.content = value
  }
}
